import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const generateGrammarAudioV1DataSchemaDefinition = z.object({
  processed: z.number().int().min(0),
  generated: z.number().int().min(0),
  skipped: z.number().int().min(0),
  pruned: z.number().int().min(0),
  done: z.boolean(),
  nextCursor: z.string().nullable(),
});

export const generateGrammarAudioV1DataSchema: typeof generateGrammarAudioV1DataSchemaDefinition =
  generateGrammarAudioV1DataSchemaDefinition;

export type IGenerateGrammarAudioV1Data = z.infer<typeof generateGrammarAudioV1DataSchema>;

export const generateGrammarAudioV1ResponseSchema: z.ZodSchema<IAPI<IGenerateGrammarAudioV1Data>> =
  createApiResponseSchema(generateGrammarAudioV1DataSchema) as z.ZodSchema<
    IAPI<IGenerateGrammarAudioV1Data>
  >;

export type IGenerateGrammarAudioV1Response = IAPI<IGenerateGrammarAudioV1Data>;
